import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Dashboard from "./Components/Dashboard/Dashboard";
import About from "./Components/About_us/Aboutus";
import Services from "./Components/Services/Services";
import Portfolio from "./Components/Portfolio/Portfolio";
import Contact from "./Components/Contact_us/Contactus";
import Blog from "./Components/Blog/Blog";
import Appdev from "./Components/Appdev/Appdev";
import UiUx from "./Components/Uiux/Uiux";
import Ecommerce from "./Components/E-Commerce/ECommerce";
import Webdev from "./Components/Webdev/Webdev";
import Digital from "./Components/Digital_Maketing/Digi";
import Quality from "./Components/Quality_Analyst/Quality";
import Careers from "./Components/Careers/Careers";
import ScrollToTop from "./ScrollToTop";

import "./App.css";
import WhatsAppButton from "./Components/WhatsAppButton/WhatsAppButton";

function App() {
  return (
    <>
      {/* MAIN CONTENT CONTAINER */}
      <Navbar />
      <main className="page-wrapper">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/appdev" element={<Appdev />} />
          <Route path="/webdev" element={<Webdev />} />
          <Route path="/quality-analyst" element={<Quality />} />
          <Route path="/digi-marketing" element={<Digital />} />
          <Route path="/uiux" element={<UiUx />} />
          <Route path="/e-commerce" element={<Ecommerce />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </main>
      <WhatsAppButton />
      <Footer />
    </>
  );
}

export default App;
